<template>
  <v-tabs>
    <v-tab
        :to="{
            name: 'PatientRecordPAGoalSettingWeeklySportsGoal',
            params: {
                patientId
            }
        }"
        :disabled="shouldBeDisabled"
    >
      {{ $ucfirst($t("pa.weeklySportsGoal")) }}
    </v-tab>
    <v-tab
        :to="{
            name: 'PatientRecordPAGoalSettingDailyActivityGoal',
            params: {
                patientId
            }
        }"
        :disabled="shouldBeDisabled"
    >
      {{ $ucfirst($t("pa.dailyActivityGoal")) }}
    </v-tab>

    <!-- Note: Release 2.0 scope reduction  -->
    <!-- <v-tab
        :to="{
            name: 'PatientRecordPAGoalSettingStrengthTraining',
            params: {
                patientId
            }
        }"
        :disabled="shouldBeDisabled"
    >
      {{ $ucfirst($t("pa.strengthTraining")) }}
    </v-tab> -->
  </v-tabs>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Component PAGoalSettingTabs.vue
 *
 * @module PAGoalSettingTabs
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/APP_DASHBOARD/templates/components/Parts/PAGoalSettingTabs.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PAGoalSettingTabs",
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    shouldBeDisabled: function() {
    //   const v = parseInt(this.$store.getters['patientSummary/currentVersion']);

    //   if (v <= 2) {
    //     return true
    //   }

    //   return false;

        return false; // For now.
    },
  }
};
</script>

<style scoped lang="scss">
.v-tab {
  max-width: 100% !important;
}
</style>
